// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TRtd","col":"styles_col__2I5OJ"};